module.exports = __webpack_public_path__ + "static/media/non_stop_5.60b17f4f.png";